import { Component } from 'san';

/**
 * @file Icon
 * @author huangxiangxiang01@baidu.com
 *
 * icon 的 css 源码在 baidu/ps-se-fe-tpl/iconfont 中
 * - wise: /src/font/cosmic/wise/cos-icon.css
 * - pc: /src/font/cosmic/pc/cos-icon.css
 */
class Icon extends Component {
    initData() {
        return {
            name: ''
        };
    }
}
Icon.trimWhitespace = 'all';
Icon.template = `
        <i class="cos-icon{{name ? ' cos-icon-' + name : ''}}"/>
    `;

export { Icon as default };
